module.exports = __webpack_public_path__ + "img/A1962.a81065d9.png";